import type { UserRole } from '@wanderlust/shared';

/**
 * Whether the web shows this person anything of Ander. It is not announced, so
 * for now only an admin sees it: the links on the public pages, the portal tabs
 * on the trips page, and every Ander route (`components/RequireAnder.tsx`).
 *
 * Announcing it is this returning true for everyone, then dropping the
 * `AnderDoor` wrapper on `/ander` and putting `/ander` back in `prerender.js`,
 * `entry-prerender.tsx`, the API's sitemap and `robots.txt`, which cannot ask.
 */
export function canSeeAnder(role: UserRole | undefined): boolean {
  return role === 'admin';
}
